<div class="progress-bar-wrapper">
    <div class="flex flex-col justify-center items-center" *ngIf="display" [@hideTransition]>
        <mat-progress-bar color="accent" mode="determinate" [value]="progress"></mat-progress-bar>
        <p>{{ progress }}% - Estimated time: {{ estimated_time }}</p>
    </div>
</div>
